import React from 'react'
import {toTitleCase} from "../../services/string";
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/outline";

// Types ----

type PermissionProps = {
  name: string
  granted: boolean
}

// Component ----

export function AppPermission({name, granted}: PermissionProps) {
  return (
    <div className='flex gap-1 items-center'>
      <p className='text-sm font-medium text-gray-500'>{toTitleCase(name)}</p>
      <div className='w-5 h-5'>{granted ? <CheckCircleIcon color='green' /> : <XCircleIcon color='red' />}</div>
    </div>
  )
}